export const unarray = <T>(arrOrValue: T | T[]): T =>
  Array.isArray(arrOrValue) ? arrOrValue[0] : arrOrValue;
